import React from 'react'
import PropTypes from 'prop-types'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CategoryTitle from '../../../CategoryTitle'
import Cta from '../../../Cta'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'



function CenteredTwoSidedContentSection({ data = {} }) {
  const { title, text, ctas, bottomImage, category = { title: '', color: {} }, theme = {} } = data

  const isLightTheme = theme.title === 'Blue' || theme.title === 'Dark blue'
  const titleClass = isLightTheme ? styles.titleLight : styles.title
  const textBlockClass = isLightTheme ? styles.textBlockLight : styles.textBlock

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value || '#E0E0E0' }}>
      <Spacer size={80}/>
      <div className={styles.mainContent}>
        {category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
        <Spacer size={16} />
        <div className={titleClass}><Text type="h1">{title}</Text></div>
        <Spacer size={32} />
        <div className={textBlockClass}>
        {text && <SimpleBlockContent blocks={text} />}
        </div>
        <Spacer size={64} />
        {ctas && (
          <div className={styles.ctas}>
            {ctas.map((cta) => (
              <Cta {...cta} key={cta._key} dark={false}/>
            ))}
          </div>
        )}
      </div>
      {/* task #67: styled bg fed the resolved descriptor url */}
      {/* DEFECT 1 (coaching LCP): this raw <img> omitted `loading`, so it defaulted
          to EAGER and Next/React auto-hoisted a bare <link rel=preload as=image> for
          it into <head> (measured: 2×~100KB bottomImages preloaded BEFORE the LCP,
          starving it under throttle). The bottomImage is a below-the-fold decorative
          image and is NEVER a page hero/LCP (no page starts with this section), so it
          must be lazy — that drops it from the eager set and kills the wasteful
          preload, leaving ONLY the resolver-chosen LCP preloaded. */}
      {/* eslint-disable-next-line local-rules/img-requires-dimensions, local-rules/prefer-img-component -- faithful styled.img->img migration; box reserved via aspect-ratio + width */}
      {bottomImage && <img className={styles.bottomImage} src={bottomImage?.src} loading="lazy" style={{ backgroundImage: `url(${bottomImage?.src})`, aspectRatio: bottomImage?.aspectRatio || '16 / 9' }} alt="" />}
    </div>
  )
}

CenteredTwoSidedContentSection.propTypes = {
  page: PropTypes.object,
  totalPages: PropTypes.number,
  pageIndex: PropTypes.number,
}

export default CenteredTwoSidedContentSection
